module.exports = __webpack_public_path__ + "img/comp.34bac99c.svg";